"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUpdatedMain = void 0;
var react_1 = require("react");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var AppUpdatedMain = function () {
    (0, react_1.useEffect)(function () {
        window.location.reload();
        (0, analyticsEventBase_1.analyticsEventBase)({ event: 'App updated reload' });
    }, []);
    return null;
};
exports.AppUpdatedMain = AppUpdatedMain;
